import React from 'react';
import { Typography, useMediaQuery } from 'fronton-react';
import { styled } from 'linaria/react';
import { BAYER_CARDS, WARRANTY_CARDS } from '../constants';
import { breakpoints } from 'media';

const CardsContainer = styled.div<{ columns: number }>`
	display: grid;
	grid-template-columns: repeat(${({ columns = 2 }) => columns}, 1fr);
	gap: 24px;
	${breakpoints.only.tablet} {
		grid-template-columns: 1fr;
	}
	${breakpoints.only.mobile} {
		grid-template-columns: 1fr;
	}
`;
const StyledCard = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 32px;
	gap: 24px;
	border-radius: var(--rounding-xl);
	border: 1px solid var(--control-minor);
	${breakpoints.only.mobile} {
		padding: 24px;
	}
`;

const RoundedNumber = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	padding: 7px 8px;
	border-radius: 100px;
	background-color: var(--brand-primary, #fdc300);
	font-size: 21px;
	font-style: normal;
	font-weight: 600;
	line-height: 28px;
	letter-spacing: 0.2px;
	text-align: center;
	color: var(--text-invert, #fff);
`;

const DescContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	height: 100%;
	width: 100%;
`;

export const CardDesk = ({ title, description }: { title: string; description: string }) => {
	const isMobile = useMediaQuery('(max-width: 767px)');
	return (
		<DescContainer>
			<Typography size="body_accent" variant={isMobile ? 'm' : 'l'}>
				{title}
			</Typography>
			<Typography size="body_long" variant={isMobile ? 'm' : 'l'}>
				{description}
			</Typography>
		</DescContainer>
	);
};

export const WarrantyCards = () => (
	<CardsContainer columns={3}>
		{WARRANTY_CARDS.map((elem, i) => (
			<StyledCard key={elem.title}>
				<RoundedNumber>{i + 1}</RoundedNumber>
				<CardDesk {...elem} />
			</StyledCard>
		))}
	</CardsContainer>
);
export const BayerCards = () => {
	const isMobile = useMediaQuery('(max-width: 767px)');
	return (
		<CardsContainer columns={2}>
			{BAYER_CARDS.map(({ icon: Icon, ...elem }) => (
				<StyledCard key={elem.title}>
					<Icon type="fill" size={isMobile ? 'xl' : 'xxl'} color="brand-primary" />
					<CardDesk {...elem} />
				</StyledCard>
			))}
		</CardsContainer>
	);
};
